export enum MobileAppStatus {
  Draft,
  Active,
  Private,
  Banned,
}
